import React, { Component } from 'react'
import { Section, Input } from '../../../../components'
import { STRING } from '../../../../helpers'
import NumberFormat from 'react-number-format'
export default class OpeningPrice extends Component {
  render() {
    const {
      auctionType,
      formData,
      isErrOpeningPrice,
      editRoleDetail,
      isSetState,
    } = this.props
    return (
      <Section className={`form-group ${isErrOpeningPrice && 'is-error'}`}>
        <label className="opening-price">
          Opening Price <br />
          {auctionType === 'Sealed' && '(Optional)'}
        </label>
        <Section className="form-group-control">
          <Section className="form-group-inner-wrapper">
            <NumberFormat
              className="input-text-right"
              value={
                formData.step2.eventInformation.eventOpeningPrice
                  ? formData.step2.eventInformation.eventOpeningPrice
                  : ''
              }
              isAllowed={inputObj => {
                const { value } = inputObj
                if (value !== '-') return true
                return false
              }}
              placeholder="0.00"
              maxLength={18}
              customInput={Input}
              decimalScale={2}
              onValueChange={e => {
                if (e.floatValue <= 0) {
                  formData.step2.eventInformation.eventOpeningPrice = null
                } else {
                  formData.step2.eventInformation.eventOpeningPrice =
                    e.floatValue
                }
                isSetState({
                  formData,
                  isErrOpeningPrice: false,
                })
              }}
              thousandSeparator={true}
              readOnly={!editRoleDetail ? true : false}
            />
          </Section>
          <Section className="message">
            {isErrOpeningPrice && STRING.INVALID}
          </Section>
        </Section>
      </Section>
    )
  }
}
